"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ProductListItem;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _reactNativeSvg = require("react-native-svg");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _icons = require("@sart/icons");
var _utilities = require("@sart/utilities");
var _Text = _interopRequireDefault(require("./Text"));
var _Price = _interopRequireDefault(require("./Price"));
var _Space = _interopRequireDefault(require("./Space"));
var _client = require("@sart/client");
var _excluded = ["serviceId", "serviceType", "serviceDescription", "onPress", "iconColor"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function ProductListItem(props) {
  var serviceId = props.serviceId,
    serviceType = props.serviceType,
    serviceDescription = props.serviceDescription,
    onPress = props.onPress,
    iconColor = props.iconColor,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  (0, _react.useEffect)(function () {}, []);
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, (0, _extends2["default"])({
    style: styles.container,
    onPress: onPress
  }, rest), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.placeholder
  }, serviceType === 'Mobile' && /*#__PURE__*/_react["default"].createElement(_icons.ProductIconType, {
    type: 'hybrid',
    color: iconColor
  }), serviceType === 'Fixedline' && /*#__PURE__*/_react["default"].createElement(_icons.ProductIconType, {
    type: 'data',
    color: iconColor
  }), serviceType === 'HomePhone' && /*#__PURE__*/_react["default"].createElement(_icons.ProductIconType, {
    type: 'minutes',
    color: iconColor
  }), serviceType === 'Media' && /*#__PURE__*/_react["default"].createElement(_icons.TV, {
    color: iconColor,
    size: 40
  })), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.body
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.header
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.title
  }, serviceId)), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 12
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.itemSubHeaderItemStyle
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: styles.description
  }, serviceDescription))));
}
ProductListItem.propTypes = {
  product: _propTypes["default"].object,
  onPress: _propTypes["default"].func
};
var styles = _reactNative.StyleSheet.create({
  container: {
    height: 72,
    width: '100%',
    flexDirection: 'row',
    borderRadius: 8,
    backgroundColor: _styles.backgroundColors.subtle,
    overflow: 'hidden'
  },
  placeholder: {
    // flex: 1,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: _styles.backgroundColors.srGreen
  },
  body: {
    flex: 1,
    padding: 12
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  title: _objectSpread(_objectSpread({
    fontSize: 14,
    lineHeight: 16
  }, _styles.typography.lightbold), {}, {
    color: _styles.colors.exisBlue
  }),
  description: {
    fontSize: 14,
    lineHeight: 24,
    color: _styles.colors.common
  },
  itemSubHeaderItemStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  productImageMobile: {
    // marginTop: 12,
    width: 72,
    alignItems: 'center',
    justifyContent: 'center'
    // backgroundColor: backgroundColors.exisOrange,
  },
  productImageWeb: {
    width: 72
  }
});